export const USER_PROFILE_LOADED_SUCCESS = 'USER_PROFILE_LOADED_SUCCESS';
export const USER_PREFERENCE_SET = 'USER_PREFERENCE_SET';
export const TERMSOFUSE_LOADED_SUCCESS = 'TERMSOFUSE_LOADED_SUCCESS';
